module.exports = __webpack_public_path__ + "img/tips-socks-icon.b9674871.svg";